module.exports = __webpack_public_path__ + "img/us_state_department.08a77e27.png";